import { BannerTypes } from '@gin-betting/banners';
import core from '@gin-betting/core';

import localeManager from 'services/locale-manager';

const {
    utils: { getBettingOptions },
    services: { stringify },
} = core;

// TODO: remove after CMS pass "getBanners" thought BettingAPI. GINFE-2607
export function getBanners(
    bannerIds: string[]
): Promise<BannerTypes.BannerInfo[]> {
    const { location, fetch } = window;

    const { locale } = getBettingOptions();

    if (!bannerIds || bannerIds.length === 0) return Promise.resolve([]);

    const idsQuery = stringify({ ids: bannerIds } as any);

    const url = `${location.origin}/api/banners/locale/${localeManager.convert(
        locale,
        {
            from: 'cms',
            to: 'banner',
        }
    )}?${idsQuery}`;

    return fetch(url, {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
    })
        .then(r => r.json())
        .then(r => r.data);
}
